<div class="pos-relative fill flex-column overflow-y-auto custom-scrollbar"
     [ngClass]="backArrow ? 'p-t-5 p-r-8 p-l-8' : 'p-l p-r'"
     [offClickOff]="!isOpen"
     [offClickFilter]="'.no-sidebar-close'"
     (offClick)="close()">
    <div class="w-12 flex flex-justify-between flex-justify-center-m flex-justify-center-s"
         [class.center]="!backArrow">
        <button class="page-sidebar-close"
                [ngClass]="{'p-a m-r--4': !backArrow}"
                [attr.aria-label]="!backArrow ? ('Close' | translate) : undefined"
                (click)="requestClose()">
            @if (backArrow) {
            <!-- back buttons -->
            <span class="flex flex-middle">
                <span class="arrow-rotation"
                      [style.line-height.px]="0"><i class="icon-arrow-forward fs-6"
                       aria-hidden="true"
                       [style.line-height.px]="0"></i></span>
                <span class="col-12 p1 m-l-3">{{'Back' | translate}}</span>
            </span>
            } @else if (!closeButton) {
            <!-- cross -->
            <i class="icon-close"
               aria-hidden="true"></i>
            }
        </button>
        @if (closeButton) {
        <button class="page-sidebar-close"
                (click)="close()">
            <i class="icon-close"
               aria-hidden="true"></i>
        </button>
        }
    </div>
    <div class="flex flex-column flex-grow pos-relative"
         [class.m-t]="backArrow">
        <ng-content />
    </div>
</div>